export const ITEM_LIST_REQUEST = 'ITEM_LIST_REQUEST'
export const ITEM_LIST_SUCCESS = 'ITEM_LIST_SUCCESS'
export const ITEM_UPDATED = 'ITEM_UPDATED'
export const ITEM_ADDED = 'ITEM_ADDED'
export const ITEM_DELETED = 'ITEM_DELETED'
export const ITEM_LIST_FAIL = 'ITEM_LIST_FAIL'

export const ITEM_UPDATE_REQUEST = 'ITEM_UPDATE_REQUEST'
export const ITEM_UPDATE_SUCCESS = 'ITEM_UPDATE_SUCCESS'
export const ITEM_UPDATE_FAIL = 'ITEM_UPDATE_FAIL'
export const ITEM_UPDATE_RESET = 'ITEM_UPDATE_RESET'

export const ITEM_ADD_REQUEST = 'ITEM_ADD_REQUEST'
export const ITEM_ADD_SUCCESS = 'ITEM_ADD_SUCCESS'
export const ITEM_ADD_FAIL = 'ITEM_ADD_FAIL'
export const ITEM_ADD_RESET = 'ITEM_ADD_RESET'

export const ITEM_DELETE_REQUEST = 'ITEM_DELETE_REQUEST'
export const ITEM_DELETE_SUCCESS = 'ITEM_DELETE_SUCCESS'
export const ITEM_DELETE_FAIL = 'ITEM_DELETE_FAIL'
export const ITEM_DELETE_RESET = 'ITEM_DELETE_RESET'


export const CATEGORY_LIST_REQUEST = 'CATEGORY_LIST_REQUEST'
export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS'
export const CATEGORY_LIST_FAIL = 'CATEGORY_LIST_FAIL'

export const CATEGORY_ADD_REQUEST = 'CATEGORY_ADD_REQUEST'
export const CATEGORY_ADD_SUCCESS = 'CATEGORY_ADD_SUCCESS'
export const CATEGORY_ADD_FAIL = 'CATEGORY_ADD_FAIL'

export const CATEGORY_UPDATE_REQUEST = 'CATEGORY_UPDATE_REQUEST'
export const CATEGORY_UPDATE_SUCCESS = 'CATEGORY_UPDATE_SUCCESS'
export const CATEGORY_UPDATE_FAIL = 'CATEGORY_UPDATE_FAIL'

export const CATEGORY_DELETE_REQUEST = 'CATEGORY_DELETE_REQUEST'
export const CATEGORY_DELETE_SUCCESS = 'CATEGORY_DELETE_SUCCESS'
export const CATEGORY_DELETE_FAIL = 'CATEGORY_DELETE_FAIL'

export const ITEM_FILTER_REQUEST = 'ITEM_FILTER_REQUEST'
export const ITEM_FILTER_SUCCESS = 'ITEM_FILTER_SUCCESS'
export const ITEM_FILTER_FAIL = 'ITEM_FILTER_FAIL'
export const ITEM_FILTER_RESET = 'ITEM_FILTER_RESET'
